import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, onMounted } from 'vue';
import { useQuery, useLazyQuery } from '@vue/apollo-composable';
import { Component, Prop, Vue } from "vue-property-decorator"
import { CircularLoader, PullRefresh } from "@coredination/components"
import StateField from "@/components/fields/StateField.vue"
import router from "@/router"

import UserDetailQuery from "@/graphql/user/userdetail.graphql"
import AssetBrief from "@/graphql/asset/assetbrief.graphql"


export default /*#__PURE__*/_defineComponent({
  __name: 'UserView',
  props: {
    uuid: null
  },
  setup(__props: any) {

const props = __props as { uuid?: string }


const user = ref<any>({});
const refreshing = ref(false);

const { onResult: onUserResult, loading: userLoading, refetch: refetchUser } = useQuery(UserDetailQuery, () => ({ 
    uuid: props.uuid }), {
    skip: () => !props.uuid,
});

const { result: assetResult, loading: assetLoading, load: fetchAsset } = useLazyQuery(AssetBrief, () => ({
    uuid: user.value?.inVehicleId }), {
});

onUserResult((result: any) => {
    if (result.data?.user) user.value = result.data.user
    if (user.value?.inVehicleId) fetchAsset();
})

const asset = computed(() => assetResult?.value?.asset);
const loading = computed(() => userLoading.value);

const refresh = async () => {
    await refetchUser();
};

const sendEmail = (email: string) => {
    window.location.href = `mailto:${email}`
}

const callPhone = (phone: string) => {
    window.location.href = `tel:${phone}`
}

const clickJob = (uuid: string) => {
    if (uuid) router.push("/job/" + uuid)
};


const clickAsset = (uuid: string) => {
    if (uuid) router.push("/asset/" + uuid)
};


return { __sfc: true,props, user, refreshing, onUserResult, userLoading, refetchUser, assetResult, assetLoading, fetchAsset, asset, loading, refresh, sendEmail, callPhone, clickJob, clickAsset, CircularLoader, PullRefresh }
}

})